import flowIcon from '@assets/image_1777447102475.png'

const TABS_LEFT  = [{ id: 'home', icon: '🏠', label: 'Home' }, { id: 'search', icon: '🔍', label: 'Search' }]
const TABS_RIGHT = [{ id: 'moods', icon: '🎭', label: 'Moods' }, { id: 'settings', icon: '⚙️', label: 'Settings' }]

function TabBtn({ tab, current, onChange }) {
  const active = current === tab.id
  return (
    <button
      onClick={() => onChange(tab.id)}
      aria-label={tab.label}
      style={{
        flex: '0 0 auto',
        background: 'none', border: 'none', cursor: 'pointer',
        padding: '8px 10px', borderRadius: 12,
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
        WebkitTapHighlightColor: 'transparent',
        transition: 'transform 0.18s',
        transform: active ? 'translateY(-1px)' : 'none',
      }}
    >
      <span style={{
        fontSize: 20,
        filter: active ? 'none' : 'grayscale(1) opacity(0.35)',
        transition: 'filter 0.15s',
      }}>{tab.icon}</span>
      <span style={{
        fontSize: 9, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase',
        color: active ? '#6ee89a' : 'rgba(110,160,120,0.55)',
        transition: 'color 0.15s',
      }}>{tab.label}</span>
      {active && (
        <div style={{
          width: 4, height: 4, borderRadius: 2,
          background: 'linear-gradient(90deg,#22c55e,#16a34a)',
          marginTop: 1,
        }} />
      )}
    </button>
  )
}

export default function TopBar({ tab, onChange }) {
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 200,
      background: 'rgba(3,10,4,0.92)',
      backdropFilter: 'blur(28px) saturate(2)',
      WebkitBackdropFilter: 'blur(28px)',
      borderBottom: '1px solid rgba(30,180,80,0.12)',
      paddingTop: 'env(safe-area-inset-top, 0px)',
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '6px 12px', minHeight: 60, gap: 6,
      }}>
        <div style={{ display: 'flex', gap: 2, flex: 1, justifyContent: 'flex-start' }}>
          {TABS_LEFT.map(t => <TabBtn key={t.id} tab={t} current={tab} onChange={onChange} />)}
        </div>

        <button
          onClick={() => onChange('home')}
          aria-label="Flow home"
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1,
            padding: '4px 14px', WebkitTapHighlightColor: 'transparent',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <img
              src={flowIcon}
              alt=""
              width="30"
              height="30"
              style={{
                width: 30, height: 30, borderRadius: 7,
                display: 'block',
                filter: 'drop-shadow(0 2px 6px rgba(80,180,220,0.35))',
              }}
            />
            <span style={{
              fontSize: 24, fontWeight: 400, letterSpacing: '-0.3px',
              fontFamily: "'DM Serif Display', Georgia, serif",
              fontStyle: 'italic',
              background: 'linear-gradient(135deg,#a5d8e8,#5db0d4)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
              backgroundClip: 'text', color: '#a5d8e8',
            }}>Flow</span>
          </div>
        </button>

        <div style={{ display: 'flex', gap: 2, flex: 1, justifyContent: 'flex-end' }}>
          {TABS_RIGHT.map(t => <TabBtn key={t.id} tab={t} current={tab} onChange={onChange} />)}
        </div>
      </div>
    </div>
  )
}
